var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cpanel"},[_c('div',{staticClass:"icon"},[_c('span',{class:_vm.classObject},[_vm._v(_vm._s(_vm.splitMyName))])])])}
var staticRenderFns = []

export { render, staticRenderFns }